import React, { useReducer, useEffect, useRef, useMemo } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
// import { CSSTransition } from 'react-transition-group';
// import { useCookies } from 'react-cookie';
// import { useAnimation } from "react-animatable";
// import { TwitterShareButton, TwitterIcon } from 'react-share';
import './App.css';
import { GlobalStateCS, useGlobalStateSelector } from './globalState';
// import logoMonachen from './monachen.png';
import logoMonacotto from './monacotto.png';
import logoKOM from './KOM.png';
import logoMonashell from './monashell.png';
import imageMonatoka from './monatoka.png';
import imageMagicShop from './magigShopTransparent.png';
import privacyPolicyHtml from './static/privacypolicy.static.html';


function App() {

  const initialState = {
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  // const [cookies, setCookie, removeCookie] = useCookies();

  const value = useMemo(
    () => ({ state, dispatch, navigate }),
    [state, dispatch, navigate]
  );

  return (
    <GlobalStateCS.Provider value={value}>
      <div className="App">
        <Routes>
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<AboutUs />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<AboutUs />} />
          {/* npm start ではサポート HTML がルート直下になり、相対の index.html が /index.html になる。そのときもトップを表示する */}
          <Route exact path="/" element={<AboutUs />} />
          <Route exact path="/index.html" element={<AboutUs />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/privacypolicy' : '/privacypolicy'} element={<PrivacyPolicyPage />} />
        </Routes>
      </div>
    </GlobalStateCS.Provider>
  );
}

function AboutUs() {
  return (
    <div className='' >
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter marginTopBottom1 ' >
        <div className='flexRow justifyContentCenter marginTopBottom1 '>
          <img className='lpMainImage' src={imageMonatoka}  alt='imageMonatoka' />
          <Tagline device='PC' />
        </div>
        <div className='flexRow justifyContentCenter marginTopBottom1 '>
          <Service device='PC' />
          <img className='lpMainImage' src={imageMagicShop} alt='imageMagicShop' />
        </div>
        <div className='flexRow justifyContentCenter marginTopBottom1 '>
          <div className='flexColumn justifyContentFlexStart alignItemsFlexStart ' >
            <CompanyProfile device='PC' />
            <div className='marginTop1 ' >
              <ContactUs device='PC' />
            </div>
            <PrivacyPolicy device='PC' />
            <NfcReaderWriterSupport device='PC' />
          </div>
          <PressRelease device='PC' />
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn alignItemsCenter width93vw '>
        <img className='widthMax' src={imageMonatoka} alt='imageMonatoka' />
        <Tagline device='SP' />
        <Service device='SP' />
        <img className='widthMax' src={imageMagicShop} alt='imageMagicShop' />
        <CompanyProfile device='SP' />
        <div className='widthMax marginTopBottom1 ' >
          <ContactUs device='SP' />
        </div>
        <PrivacyPolicy device='SP' />
        <NfcReaderWriterSupport device='SP' />
        <PressRelease device='SP' />
      </div>
    </div>
  );
}

// TAGLINE
function Tagline(props) {
  const device = props.device || 'PC';
  let width;

  if (device === 'PC') {
    width = 'lpMainImage';
  }
  else {
    width = 'widthMax';
  }

  return (
    <div className={ width + ' lpMainImage flexColumn justifyContentCenter alignItemsCenter ' } >
      <div className='font2 marginTopBottom1' >
        {/*
          モナコインを世の中に広める<br/>
          とか、そうゆう仕事をする会社です。
        */}
        ビットコインの正しい知識と、<br/>
        モナコインの楽しさを広めます！
      </div>
      {/*
        <div className='font1p5 marginTopBottom1' >
          モナコインは、2013年12月に日本で誕生した暗号資産です。ビットコインと同様、管理・運営者のいない非中央集権的暗号資産であり、ビットコインのソースコードを基に作られているため、日本人が最初に触れる暗号資産としてふさわしいとモナトカは考えます。モナトカは、モナコインを通じて暗号資産の普及を促進していきます。
        </div>
      */}
    </div>
  );
}

// SERVICE
function Service(props) {
  const device = props.device || 'PC';
  let width;
  let widthImage;

  if (device === 'PC') {
    width = 'lpMainImage';
    widthImage = 'width24';
  }
  else {
    width = 'widthMax';
    widthImage = 'width85PC';
  }


  return (
    <div className={ width + ' lpMainImage flexColumn justifyContentCenter alignItemsCenter ' } >
      <div className='flexColumn justifyContentCenter alignItemsFlexStart '>
        <div className='textLeft margin1 font1p5'>
          提供サービス
        </div>
        {/*
          <div className='flexColumn alignItemsFlexStart margin1 '>
            <div className='marginSide1'>
              モナコイン決済でのJPYCの販売・買取
            </div>
            <button className='borderNone backgroundColorTransparent margin1 cursor'
              onClick={ () => {
                window.open(`https://${process.env.REACT_APP_MONACHEN_MAIN_URL}`);
              }}
            >
              <img className='width24' src={logoMonachen} />
            </button>
          </div>
        */}
        <div className='flexColumn alignItemsFlexStart margin1 '>
          <div className='marginSide1'>
            モナカード マーケットプレイス
          </div>
          <button className='borderNone backgroundColorTransparent margin1 cursor'
            onClick={ () => {
              window.open(`https://${process.env.REACT_APP_MONACOTTO_MAIN_URL}`);
            }}
          >
            <img className={widthImage} src={logoMonacotto} alt='logoMonacotto' />
          </button>
        </div>
        <div className='flexColumn alignItemsFlexStart margin1 '>
          <div className='marginSide1'>
            モナカードでAIカードバトル！
          </div>
          <button className='borderNone backgroundColorTransparent margin1 cursor'
            onClick={ () => {
              window.open(`https://${process.env.REACT_APP_KOM_MAIN_URL}`);
            }}
          >
            <img className={widthImage} src={logoKOM} alt='logoKnightsOfMonadom' />
          </button>
        </div>
        <div className='flexColumn alignItemsFlexStart margin1 '>
          <div className='marginSide1'>
            モナコイン＆モナカード・ウォレット
          </div>
          <button className='borderNone backgroundColorTransparent margin1 cursor'
            onClick={ () => {
              window.open(`https://${process.env.REACT_APP_MONASHELL_MAIN_URL}`);
            }}
          >
            <img className={widthImage} src={logoMonashell} alt='logoMonashell' />
          </button>
        </div>
      </div>
    </div>
  );
}

// COMPANY PROFILE
function CompanyProfile(props) {
  const device = props.device || 'PC';
  let width;

  if (device === 'PC') {
    width = '';
  }
  else {
    width = 'widthMax';
  }


  return (
    <div className={ width + ' flexColumn alignItemsFlexStart margin1 ' } >
      <div className='flexRow margin1'>
        <div className='width10'>
          会社名
        </div>
        <div className=''>
          株式会社モナトカ
        </div>
      </div>
      <div className='flexRow margin1'>
        <div className='width10'>
          代表取締役
        </div>
        <div className=''>
          渡邉潤平
        </div>
      </div>
      <div className='flexRow margin1'>
        <div className='width10'>
          所在地
        </div>
        <div className=''>
          〒101-0051 東京都千代田区神田神保町2-10-31 IWビル1F
        </div>
      </div>
      <div className='flexRow margin1'>
        <div className='width10'>
          設立
        </div>
        <div className=''>
          2022年2月1日
        </div>
      </div>
      <div className='flexRow margin1'>
        <div className='width10'>
          資本金
        </div>
        <div className=''>
          5,000,000円
        </div>
      </div>
      <div className='flexRow margin1'>
        <div className='width10'>
          事業内容
        </div>
        <div className=''>
          {/* 前払式支払手段の販売・買取、モナカードのマーケットプレイスの提供 等 */}
          モナカードのマーケットプレイスの提供、オンラインゲームの提供 等
        </div>
      </div>
      <div className='flexRow margin1'>
        <div className='width10'>
          顧問税理士
        </div>
        <div className=''>
          税理士法人　堀口会計
        </div>
      </div>
    </div>
  );
}

// CONTACT US
function ContactUs(props) {
  const device = props.device || 'PC';
  let width;

  if (device === 'PC') {
    width = 'lpMainImage';
  }
  else {
    width = 'widthMax';
  }


  return (
    <div className={ width + ' lpMainImage flexColumn justifyContentCenter alignItemsCenter ' } >
      <div className='flexColumn justifyContentCenter alignItemsFlexStart '>
        <div className='breakWord'>
          当社へのお問い合わせは、以下のメールアドレスまでご連絡ください。
        </div>
        <button className='borderNone backgroundColorTransparent marginTop1 font1 cursor'
          onClick={ () => {
            window.open('mailto:m6a.contact@gmail.com');
          }}
        >
          { 'm6a.contact@gmail.com' }
        </button>
      </div>
    </div>
  );
}

// PRIVACY POLICY
function PrivacyPolicy({ device = 'PC' }) {
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  let width;

  if (device === 'PC') {
    width = 'lpMainImage';
  }
  else {
    width = 'widthMax';
  }

  return (
    <div className={ width + ' flexColumn justifyContentCenter alignItemsCenter ' } >
      <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink'
        onClick={ () => {
          navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/privacypolicy' : '/privacypolicy');
        }}
      >
        プライバシーポリシー
      </button>
    </div>
  );
}

// NFC READER WRITER SUPPORT
// public 配下の静的 HTML へ遷移する。React Router ではなく実ファイルを開く
function NfcReaderWriterSupport({ device = 'PC' }) {
  let width;

  if (device === 'PC') {
    width = 'lpMainImage';
  }
  else {
    width = 'widthMax';
  }

  return (
    <div className={ width + ' flexColumn justifyContentCenter alignItemsCenter ' } >
      <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink'
        onClick={ () => {
          window.location.href = process.env.PUBLIC_URL + '/nfcrw-support.html';
        }}
      >
        monatoka NFC Reader & Writer サポート
      </button>
    </div>
  );
}

// 履歴があれば前の画面へ。直アクセスなどで履歴がなければ AboutUs へ
function handleClickBack({ navigate }) {
  if (window.history.state.idx > 0) {
    navigate(-1);

    return;
  }

  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/');
}

// プライバシーポリシー本文。/privacypolicy で直接アクセスできる
function PrivacyPolicyPage() {
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  return (
    <div className='textLeft margin1'>
      <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink'
        onClick={ () => {
          handleClickBack({ navigate });
        }}
      >
        戻る
      </button>
      <div dangerouslySetInnerHTML={ { __html: privacyPolicyHtml } } />
    </div>
  );
}

// PRESS RELEASE
function PressRelease(props) {
  const device = props.device || 'PC';
  let width;

  if (device === 'PC') {
    width = 'lpMainImage';
  }
  else {
    width = 'widthMax';
  }


  return (
    <div className={ width + ' flexColumn justifyContentFlexStart alignItemsFlexStart ' } >
      <div className='textLeft margin1 font1p5'>
        プレスリリース
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2022年6月14日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000002.000100288.html'); } }
        >
          モナコインでJPYCが買える・売れるサービス「もなちぇん」。取引上限額が500MONA(※1)にアップ！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2022年10月28日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000003.000100288.html'); } }
        >
          モナコイン(N)FT「モナカード」のマーケットプレイス「もなこっと」が誕生！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2023年4月1日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000004.000100288.html'); } }
        >
          「自分の財産は自分で守る」― ビットコイン、モナコインなどの暗号資産の普及を目指します。
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2023年6月22日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000005.000100288.html'); } }
        >
          ChatGPTとモナカードで融合召喚！新感覚AIカードバトルゲーム「Knights of Monadom」誕生！！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2023年7月31日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000006.000100288.html'); } }
        >
          ChatGPT＆モナカードゲーム「Knights of Monadom」一般クリエイターカード登録受付開始！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2023年9月29日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000007.000100288.html'); } }
        >
          ChatGPTカードバトルゲーム「Knights of Monadom(愛称モナダム)」に魔法カードが加わりました！！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2023年11月30日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000008.000100288.html'); } }
        >
          ChatGPTカードバトルゲーム「Knights of Monadom(愛称モナダム)」が日本円で遊べるようになりました！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2024年1月31日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000009.000100288.html'); } }
        >
          AIカードバトルゲーム「Knights of Monadom」が簡単に遊べる「モナダムキーカードNFC」新発売！
        </button>
      </div>
      <div className='flexColumn alignItemsFlexStart margin1 '>
        <div className='marginSide1'>
          2025年6月25日
        </div>
        <button className='borderNone backgroundColorTransparent margin1 cursor fontHyperLink textLeft'
          onClick={ () => { window.open('https://prtimes.jp/main/html/rd/p/000000010.000100288.html'); } }
        >
          モナトカとHonmono協会、コミュニティ内通貨「ホンモノコイン」を正式ローンチ
        </button>
      </div>
    </div>
  );
}

// ------------------------------------------------------------------------------------------------------------

// DECIMAL ADJUST
function decimalAdjust(type, value, exp) {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  // If value is Infinity...
  if (value === Infinity) {
    return Infinity;
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

// REDUCER
function reducer(state, action) {
  let newState = { ...state };
  let numericCharacter;
  let number;
  let amountMona;
  let amountJpyc;
  let isChanged;
  let items;
  let item;
  let newIndex;

  switch (action.type) {
    case 'setState':
      newState[action.key] = action.value;
      return newState;

    case 'setStateMultiLayers':
      action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc;
        }
        if (idx === src.length - 2) {
          return acc[cur] = src[idx + 1];
        }
        else {
          return acc[cur];
        }
      }, newState );
      return newState;

    case 'setStateNum':
      number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;

    case 'setStateMultiLayersNum':
      number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        number = ''
      }

      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc[cur] = number;
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;

    case 'setStateFloat':
      number = parseFloat(action.value);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;

    // setStateMultiLayersFloat
    case 'setStateMultiLayersFloat':
      numericCharacter = action.value.replace(/[^\d.]/, '');
      number = parseFloat(numericCharacter);

      if (Number.isNaN(number)) {
        number = ''
      }
      else if (action.adjustType !== undefined) {
        number = decimalAdjust(action.adjustType, number, action.adjustExp);
      }

      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          acc[cur].face = numericCharacter;
          acc[cur].value = number;
          return acc[cur];
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;

    // adjustFace
    case 'adjustFace':
      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          acc[cur].face = acc[cur].value;
          return acc[cur];
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;

    // pushOut
    case 'pushOut':
      const target = action.targetKeys.reduce( (acc, cur) => {
          return acc[cur];
      }, newState );

      action.keys.reduce( (acc, cur, idx, src) => {
        const pushedOut = target[cur];
        target[cur] = acc;
        return  pushedOut;
      }, action.value );

      return newState;

    case 'setStateIfChange':
      if (newState[action.key] != action.value) {
        newState[action.key] = action.value;
        return newState;
      }
      else {
        return state;
     }

    case 'setStateMultiLayersIfChange':
      isChanged = action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc;
        }
        if (idx === src.length - 2) {
          if (acc[cur] !== src[idx + 1]) {
            acc[cur] = src[idx + 1];
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return acc[cur];
        }
      }, newState );

      if (isChanged) {
        return newState;
      }
      else {
        return state;
      }

    // setNotification
    case 'setNotification':
      newState[action.key].body.push(action.value);

      if (newState[action.key].body.length > state.config.clientParameters.notificationMaxLength) {
        newState[action.key].body.shift();
      }

      newState[action.key].index = newState[action.key].body.length -1;

      newState[action.key].inAnimation = true;

      return newState;

    case 'stopNotificationAnimation':
      newState[action.key].inAnimation = false;
      return newState;

    // itemReplace
    case 'itemReplace':
      items = newState.items[newState.gallery.addressMain].itemPlacement[0].items;
      item = items[action.index];

      if (action.direction === 'left') {
        newIndex = action.index - 1 >= 0 ? action.index -1 : items.length - 1;
      }
      else { // right
        newIndex = action.index + 1 <= items.length - 1 ? action.index + 1 : 0;
      }

      items.splice(action.index, 1);
      items.splice(newIndex, 0, item);

      return newState;

    // default
    default:
      return state;
  }
}


export default App;
